import { useState, useEffect } from 'react';

export const useMemory = () => {
  const [memoryEnabled, setMemoryEnabled] = useState(true);
  const [conversationId, setConversationId] = useState(null);
  const [memoryStats, setMemoryStats] = useState(null);
  const [relevantMemories, setRelevantMemories] = useState([]);
  const [showMemoryPanel, setShowMemoryPanel] = useState(false);
  
  // Session tracking for memory persistence across page refreshes
  const [sessionId, setSessionId] = useState("legal_ai_persistent_session");  // Single persistent session for all time

  const generateConversationId = () => {
    return 'conv_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  };

  const fetchMemoryStats = async () => {
    try {
      const response = await fetch('/api/zep/stats');
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const stats = {
            total_nodes: data.stats ? data.stats.total_facts : 0,
            interactions: 0,
            corrections: 0,
            feedback: 0,
            facts: data.stats ? data.stats.total_facts : 0,
            memory_type: 'zep_cloud'
          };
          setMemoryStats(stats);
        }
      }
    } catch (error) {
      console.error('Error fetching memory stats:', error);
    }
  };

  const clearMemory = async () => {
    try {
      // Use the correct endpoint that actually deletes data from Zep cloud
      const response = await fetch('/api/zep/clear', {
        method: 'POST'
      });
      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          setMemoryStats(null);
          setRelevantMemories([]);
          console.log('✅ Memory cleared from cloud successfully:', result.result);
          // Refresh memory stats to show cleared state
          fetchMemoryStats();
          return true;
        } else {
          console.error('Clear memory failed:', result.error);
          return false;
        }
      }
      return false;
    } catch (error) {
      console.error('Error clearing memory:', error);
      return false;
    }
  };

  // Initialize conversation ID and fetch memory stats on component mount
  useEffect(() => {
    if (!conversationId) {
      setConversationId(generateConversationId());
    }
    fetchMemoryStats();
  }, []);

  // Update memory stats periodically
  useEffect(() => {
    const interval = setInterval(fetchMemoryStats, 30000); // Every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return {
    memoryEnabled,
    setMemoryEnabled,
    conversationId,
    setConversationId,
    memoryStats,
    relevantMemories,
    setRelevantMemories,
    showMemoryPanel,
    setShowMemoryPanel,
    sessionId,
    fetchMemoryStats,
    clearMemory,
    generateConversationId
  };
};
